import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { BarChart, Bar, ResponsiveContainer, XAxis, Tooltip, Cell } from "recharts";
import { CalendarDays, MessageCircle, Inbox, UserX, Users } from "lucide-react";

export default function Analytics() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/analytics").then((r) => setData(r.data)).catch((e) => toast.error(apiErr(e)));
  }, []);

  if (!data) return <p className="text-slate-400 py-12 text-center">Caricamento...</p>;

  const kpis = [
    { label: "Prenotazioni totali", value: data.total, icon: CalendarDays, color: "bg-primary/10 text-primary" },
    { label: "Confermate/completate", value: data.confirmed, icon: MessageCircle, color: "bg-emerald-100 text-emerald-700" },
    { label: "Lead dal portale", value: data.leads, icon: Inbox, color: "bg-sky-100 text-sky-700" },
    { label: "No-show", value: `${data.no_show} (${data.no_show_rate}%)`, icon: UserX, color: "bg-amber-100 text-amber-700" },
    { label: "Clienti in anagrafica", value: data.customers, icon: Users, color: "bg-slate-100 text-slate-700" },
  ];

  const trend = data.trend.map((t) => ({ ...t, label: new Date(t.date).toLocaleDateString("it-IT", { weekday: "short" }) }));

  return (
    <div className="space-y-5" data-testid="analytics-page">
      <div>
        <p className="text-xs font-bold uppercase tracking-wider text-primary">Statistiche</p>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Panoramica attività</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        {kpis.map((k) => (
          <div key={k.label} className="bg-white border border-slate-200 rounded-2xl p-4" data-testid={`analytics-kpi-${k.label}`}>
            <div className={`grid h-9 w-9 place-items-center rounded-lg ${k.color} mb-2`}><k.icon className="h-5 w-5" /></div>
            <p className="font-heading text-xl font-bold text-slate-900">{k.value}</p>
            <p className="text-xs text-slate-500 mt-0.5">{k.label}</p>
          </div>
        ))}
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-4 sm:p-6">
        <p className="font-heading font-bold text-slate-900 mb-4">Andamento prenotazioni (ultimi 7 giorni)</p>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={trend}>
              <XAxis dataKey="label" tickLine={false} axisLine={false} fontSize={12} stroke="#94a3b8" />
              <Tooltip cursor={{ fill: "rgba(224,90,54,0.05)" }} contentStyle={{ borderRadius: 12, border: "1px solid #e2e8f0" }} />
              <Bar dataKey="count" radius={[8, 8, 0, 0]}>
                {trend.map((_, i) => <Cell key={i} fill="#E05A36" />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
